import { TileImage } from "ol/source";

const tileImage = (url: string) =>
  new TileImage({
    url,
    crossOrigin: "anonymous",
  });

export default tileImage;
